import React, { Fragment } from 'react';
import { IconSearch } from '@grpn/mx-components';
import Select, { components } from 'react-select';
import './multiselect.styl';
import classNames from 'classnames';
import { ListOfPds, BusinessType } from '../../types';
import { I18n, getTranslator } from '../../helpers/i18n';

const translate = getTranslator('_businessInfo');
interface StringMap {
  [key: string]: any;
}
type OptionType = StringMap;
type OptionsType = Array<OptionType>;
type ValueType = OptionType | OptionsType;

type CommonProps = {
  clearValue: () => void;
  getValue: () => ValueType;
  hasValue: boolean;
  isMulti: boolean;
  options: OptionsType;
};

type pdsProps = {
  errorMessage: string | undefined;
  hasError: Boolean;
  id: string;
  listOfPds: ListOfPds[];
  listOfSelectedPds: BusinessType[];
  onChangeMultiSelect: (value: BusinessType[]) => void;
  onInputChange: (value: string) => void;
  selectedPdsItems: string;
  showRequiredMark: Boolean;
};

const Menu = (props: CommonProps) => {
  const optionSelectedLength = props.getValue().length || 0;
  if (optionSelectedLength < 3) {
    return <components.Menu {...props} />;
  } else {
    return (
      <components.Menu {...props}>
        <div className={'pds-select pds__menu-notice pds__max_limit'}>
          {translate(`maxPdsLimit`)}
        </div>
      </components.Menu>
    );
  }
};

const DropdownIndicator = (props: {
  getStyles: any;
  innerProps: { [x: string]: any; ref: any };
}) => {
  const {
    innerProps: { ref, ...restInnerProps },
  } = props;
  return (
    <div {...restInnerProps} ref={ref}>
      <div style={{ padding: '0px 5px' }}>
        <IconSearch size={24} color={'groupon-green'} />
      </div>
    </div>
  );
};

export default function Multiselect(props: pdsProps) {
  const { hasError, errorMessage } = props;
  return (
    <Fragment>
      <Select
        selectedPdsItems
        components={{ Menu, DropdownIndicator: DropdownIndicator }}
        isMulti
        options={props.listOfPds}
        onChange={props.onChangeMultiSelect}
        className="pds-container"
        classNamePrefix={`${classNames({
          error: props.hasError,
        })} pds-select pds`}
        placeholder={translate(`pdsPlaceholder`)}
        noOptionsMessage={() => null}
        onInputChange={props.onInputChange}
        isSearchable={props.listOfSelectedPds.length < 3 ? true : false}
      />
      {hasError && errorMessage ? <span className="mx-error-message">{errorMessage}</span> : null}
    </Fragment>
  );
}
